<template>
  <b-nav-item-dropdown right>
    <template #button-content>
      <i class="fa fa-language"></i> {{ $root.locale.toUpperCase() }}
    </template>
    <b-dropdown-item href="#" @click.prevent="$root.changeLocale('nl')">Dutch</b-dropdown-item>
    <b-dropdown-item href="#" @click.prevent="$root.changeLocale('en')">English</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: 'LocaleDropdown',
  }
</script>
